(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asap-owned-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-asap-banner-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-asap-banner-slide]')];
    const previous = root.querySelector('[data-asap-banner-previous]');
    const next = root.querySelector('[data-asap-banner-next]');
    if (slides.length < 2 || !previous || !next) return;
    let active = slides.findIndex((slide) => slide.dataset.active === 'true');
    if (active < 0) active = 0;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.dataset.active = selected ? 'true' : 'false';
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        if (selected) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
    }

    previous.addEventListener('click', () => show(active - 1));
    next.addEventListener('click', () => show(active + 1));
    show(active);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
